import Server from "next/dist/next-server/server/next-server"
import { getRequestFullUrl } from "../utils"
import { defaultRoutes } from "./setup"
import { addSlugsToPath, defaultRouterHandler, getFullUrlWithoutSlugs } from "./utils"
import { getServerWlDomainData } from "./whitelabeledDomains"

export const routesMiddleware = (app: Server) => {
    return (req, res) => {
        const path = removeIndexHtmlFromPath(req.url)
        const nextHandler = app.getRequestHandler()

        // For "_next" static files skip to default
        if (path.includes("_next")) {
            defaultRouterHandler(req, res, app, nextHandler)
            return
        }

        // Whitelabeled domains
        const wlDomain = getServerWlDomainData(req.header("host"))
        if (wlDomain) {
            // If path does not contain accountSlug/terminalSlug construct "real" path with those
            // This will imitate scenario as if the accountSlug and terminalSlug were actually present in url
            const pathWithSlugs = addSlugsToPath(path, wlDomain)
            // Get router info from this constructed path (which page should be rendered, queries etc.)
            const { route, query, parsedUrl } = defaultRoutes.match(pathWithSlugs)

            if (route) {
                // Skip if requested path is password reset page or terms of service etc.
                if (route.page !== "/main" && route.page !== "/locationSelect") {
                    app.render(req, res, route.page, query)
                    return
                }

                // If actual request url contains accountSlug/terminalSlug, redirect to url without those
                const fullUrl = getRequestFullUrl(req)
                const urlWithouSlugs = getFullUrlWithoutSlugs(fullUrl, wlDomain)
                if (urlWithouSlugs !== fullUrl) {
                    res.redirect(301, urlWithouSlugs)
                }

                // Set accountSlug/terminalSlug router.query object so we can work with it within app
                query.accountSlug = wlDomain.account_slug
                if (wlDomain.terminal_slug) {
                    query.locationSlug = wlDomain.terminal_slug
                }

                res.locals[RES_DOMAIN_DATA] = wlDomain
                app.render(req, res, route.page, query)
            } else {
                nextHandler(req, res, parsedUrl)
            }
            return
        }

        // Default router logic for non-whitelabeled domains
        defaultRouterHandler(req, res, app, nextHandler)
        return
    }
}

export const RES_DOMAIN_DATA = "RES_DOMAIN_DATA"

const removeIndexHtmlFromPath = (path: string) => path.replace("index.html", "")
